"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerCreateMultipleOrdersInput = exports.CustomerCreateOrderInput = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const customer_1 = require("../customer");
const order_1 = require("../order");
const alliance_order_transport_1 = require("../order/alliance-order-transport");
exports.CustomerCreateOrderInput = typebox_1.Type.Object({
    requestedDeliveryDate: typebox_1.Type.Union([typebox_1.Type.String({ format: 'date' }), typebox_1.Type.String({ format: 'date-time' })]),
    requestedSize: typebox_1.Type.Object({
        size: typebox_1.Type.Number(),
        type: typebox_1.Type.String(),
    }),
    requestedPickupDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    material: typebox_1.Type.String(),
    serviceLocation: order_1.ServiceLocationTransport,
    // These might be removed if they end up encoded into the `signedQuote` field.
    rentalPeriod: order_1.DurationTransport,
    weightLimit: order_1.WeightTransport,
    signedQuote: typebox_1.Type.String(),
    stripeToken: typebox_1.Type.Optional(typebox_1.Type.String()),
    stripeCustomer: typebox_1.Type.Optional(typebox_1.Type.String()),
    email: typebox_1.Type.Optional(typebox_1.Type.String()),
    switchedFromOrderID: typebox_1.Type.Optional(typebox_1.Type.String()),
    sharedDeliveryNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    sharedPickupNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    byCheck: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    paymentTerm: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.CustomerCreateMultipleOrdersInput = typebox_1.Type.Object({
    email: typebox_1.Type.String(),
    firstName: typebox_1.Type.String(),
    lastName: typebox_1.Type.String(),
    phone: typebox_1.Type.String(),
    billingAddress: common_1.AddressTransport,
    stripeToken: typebox_1.Type.String(),
    leadID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerType: customer_1.CustomerType,
    companyName: typebox_1.Type.Optional(typebox_1.Type.String()),
    promotionCode: typebox_1.Type.Optional(typebox_1.Type.String()),
    orderReferralParty: typebox_1.Type.Optional(typebox_1.Type.Union([alliance_order_transport_1.PartnerCheckout, typebox_1.Type.Literal('SELF_CHECKOUT'), typebox_1.Type.Literal('GUIDED_CHECKOUT')])),
    orders: typebox_1.Type.Array(typebox_1.Type.Object({
        requestedDeliveryDate: typebox_1.Type.Union([typebox_1.Type.String({ format: 'date' }), typebox_1.Type.String({ format: 'date-time' })]),
        requestedSize: typebox_1.Type.Object({
            size: typebox_1.Type.Number(),
            type: typebox_1.Type.String(),
        }),
        requestedPickupDate: typebox_1.Type.Optional(typebox_1.Type.String()),
        material: typebox_1.Type.String(),
        serviceLocation: order_1.ServiceLocationTransport,
        // These might be removed if they end up encoded into the `signedQuote` field.
        rentalPeriod: order_1.DurationTransport,
        weightLimit: order_1.WeightTransport,
        signedQuote: typebox_1.Type.String(),
        sharedDeliveryNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
        sharedPickupNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
        paymentTerm: typebox_1.Type.Optional(typebox_1.Type.String()),
    })),
});
//# sourceMappingURL=CustomerCreateOrderInput.js.map